const accountId = (value) => String(value ?? '').trim();

/**
 * Keep only account IDs present in the editor's current accessible-account
 * list. The selected home account is always first and duplicate/stale legacy
 * IDs are removed before a User mutation is sent.
 */
export const canonicalizeAccountAllocations = (
  accounts,
  homeAccountId,
  allocations,
) => {
  const allowedIds = new Set(
    (Array.isArray(accounts) ? accounts : [])
      .map((account) => accountId(account?._id))
      .filter(Boolean),
  );
  const homeId = accountId(homeAccountId);
  const candidates = Array.isArray(allocations) ? allocations : [];
  const result = [];

  [homeId, ...candidates.map(accountId)].forEach((candidate) => {
    if (!candidate || !allowedIds.has(candidate) || result.includes(candidate)) return;
    result.push(candidate);
  });

  return result;
};
